import {
  Directive,
  Input,
  ElementRef,
  HostListener,
  Renderer2,
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { interval } from "rxjs/observable/interval";
import { Subscription } from "rxjs/Subscription";

@Directive({
  selector: "[tooltip]",
})
export class TooltipDirective {
  @Input("tooltip") public tooltipTitle: string;
  @Input() public placement: "top" | "bottom" | "left" | "right" = "top";
  /** delay in milliseconds */
  @Input() public delay: number = 200;
  @Input() public waitForChangeDetection: number = 700;
  private tooltip: HTMLElement;
  private offset = 10;
  private intervalSubscription: Subscription;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener("mouseenter") onMouseEnter() {
    if (!this.tooltipTitle.trim()) {
      return;
    }
    if (!this.tooltip) {
      this.show();
    }
  }

  @HostListener("mouseleave") onMouseLeave() {
    if (this.tooltip) {
      this.hide();
    }
  }
  public checkIfStillExists() {
    try {
      const elementTop =
        this.elementRef.nativeElement.getBoundingClientRect().top;
      const tooltipTop = this.tooltip.getBoundingClientRect().top;

      if (Math.abs(elementTop - tooltipTop) > 100) {
        this.hide();
      }
    } catch (err) {
      this.hide();
    }
  }
  public subscribeToCheckChanges() {
    if (this.intervalSubscription && !this.intervalSubscription.closed) {
      return;
    }
    this.intervalSubscription = interval(this.waitForChangeDetection).subscribe(
      () => {
        this.checkIfStillExists();
      }
    );
  }

  public show() {
    this.create();
    this.setPosition();
    this.renderer.addClass(this.tooltip, "app-tooltip-show");
    this.subscribeToCheckChanges();
  }

  public hide() {
    this.renderer.removeClass(this.tooltip, "app-tooltip-show");
    if (this.intervalSubscription && !this.intervalSubscription.closed) {
      this.intervalSubscription.unsubscribe();
    }
    window.setTimeout(() => {
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }, this.delay);
  }

  create() {
    this.tooltip = this.renderer.createElement("span");

    this.renderer.appendChild(
      this.tooltip,
      this.renderer.createText(this.tooltipTitle) // textNode
    );

    this.renderer.appendChild(document.body, this.tooltip);

    this.renderer.addClass(this.tooltip, "app-tooltip");
    this.renderer.addClass(this.tooltip, `app-tooltip-${this.placement}`);

    this.renderer.setStyle(
      this.tooltip,
      "-webkit-transition",
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      "-moz-transition",
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      "-o-transition",
      `opacity ${this.delay}ms`
    );
    this.renderer.setStyle(
      this.tooltip,
      "transition",
      `opacity ${this.delay}ms`
    );
  }

  setPosition() {
    const hostPos = this.elementRef.nativeElement.getBoundingClientRect();

    const tooltipPos = this.tooltip.getBoundingClientRect();

    const scrollPos =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    // tslint:disable-next-line:one-variable-per-declaration
    let top, left;

    if (this.placement === "top") {
      top = hostPos.top - tooltipPos.height - this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.placement === "bottom") {
      top = hostPos.bottom + this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.placement === "left") {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.left - tooltipPos.width - this.offset;
    }

    if (this.placement === "right") {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.right + this.offset;
    }

    this.renderer.setStyle(this.tooltip, "top", `${top + scrollPos}px`);
    this.renderer.setStyle(this.tooltip, "left", `${left}px`);
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/app-tooltip.directive.ts